module.exports = __webpack_public_path__ + "img/arrow.bd614f96.svg";